import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getAnalytics, isSupported, type Analytics } from "firebase/analytics";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBmWJbF9xmHRgC--F5O39p9jWJkQl6t6Co",
  authDomain: "pithplay-world.firebaseapp.com",
  projectId: "pithplay-world",
  storageBucket: "pithplay-world.appspot.com",
  messagingSenderId: "248664569090",
  appId: "1:248664569090:web:736b39bf28932590a53e1b",
  measurementId: "G-0WRZ24VCK7"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

let analytics: Analytics | undefined;

// Analytics is optional and not supported in all environments (e.g. Jest/jsdom).
if (typeof window !== 'undefined' && process.env.NODE_ENV !== 'test') {
  isSupported()
    .then((supported) => {
      if (supported) {
        analytics = getAnalytics(app);
      }
    })
    .catch(() => {
      // Ignore analytics init failures (e.g. blocked IndexedDB)
    });
}

export { auth, analytics };
